import DHTMLPopupWithMoire from './dhtml_popup_with_moire'

export default class UnhideableMoire extends DHTMLPopupWithMoire {
    constructor(popupId, moireDivId) {
        super(popupId, moireDivId)
    }

    hideOnMouseDown = () => false

    hideOnEscape = () => false

    hideOnResize = () => false

}


// WEBPACK FOOTER //
// ./web/js/UnhideableMoire.js